import PropTypes from 'prop-types';

const PostHeader = (props) => {
  const {
    value = '',
  } = props;
  return (
    <div id={`${props.type}-${props.index}`} className="header" style={props.inlineStyles} dangerouslySetInnerHTML={{__html: value}} />
  )
}

PostHeader.propTypes = {
  value: PropTypes.string
};

export default PostHeader;